module.exports = __webpack_public_path__ + "static/media/ND-2.0-MX5.e8022d24.jpg";